import { graphql } from 'react-relay';

export const AttachmentListFragment = graphql`
    fragment AttachmentListFragment on Query
    @argumentDefinitions(
        model_type: { type: "String!" }
        model_id: { type: "String!" }
        first: { type: "Int" }
        page: { type: "Int" }
    ) {
        attachments(model_type: $model_type, model_id: $model_id, page: $page, first: $first)
            @connection(key: "AttachmentFragment_attachments") {
            edges {
                cursor
                node {
                    id
                    ...AttachmentFragment
                }
            }
            ...AttachmentConnectionFragment
        }
    }
`;
